import React, { useEffect, useState } from "react";
import { useOrderManagementStore } from "./store";
import OrderManagement from "./OrderManagement";
import { Button } from "react-bootstrap";
import OrderManagementTable from "./OrderManagementTable";
import CardDiv from "modules/common/card-div/CardDiv";
import SoftBadge from "modules/common/SoftBadge";
import ImportantNotes from "modules/order_management/ImportantNotes";
import { Modal } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import SearchForm from "./SearchForm";
import {Spinner} from "react-bootstrap";
import SecondSearchForm from "./SecondSearchForm";

const OrderMovement = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuerySecond, setSearchQuerySecond] = useState("");
  const [selectedFirstItem, setSelectedFirstItem] = useState(null);
  const [selectedSecondItem, setSelectedSecondItem] = useState(null);
  const [search, setSearch] = useState(0);
  const [searchSecond, setSearchSecond] = useState(0);
  const [displaySecond, setDisplaySecond] = useState("show");
  const [displayFirst, setDisplayFirst] = useState("show");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [order, setOrder] = useState([]);
  const [fromCaseId, setFromCaseId] = useState(null);
  const [toCaseId, setToCaseId] = useState(null);
  const [caseSetFirst, setCaseSetFirst] = useState(null);
  const [caseSetSecond, setCaseSetSecond] = useState(null);
  const [submitFlag, setSubmitFlag] = useState(0);
  const [refresh, setRefresh] = useState(0);

  const {
    caseData,
    caseDataTo,
    caseDataLoading,
    updateLoading,
    fetchOrderCaseData,
    fetchOrderCaseDataTo,
    updateMoveOrder,
  } = useOrderManagementStore();
  const { setToaster } = useToast();

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        setSearchQuery("");
        setSearchQuerySecond("");
        setSearch(0);
        setSearchSecond(0);
        setSelectedFirstItem([]);
        setSelectedSecondItem([]);
        setOrder([]);
        setToCaseId(null);
        setRefresh(0);
      }, 1500);
    }
  }, [refresh]);

  useEffect(() => {
    searchSecond ? setCaseSetSecond(caseData) : setCaseSetFirst(caseData);
  }, [caseData, caseDataTo]);

  useEffect(() => {
    if (submitFlag) {
      const payload = {
        toCaseId: toCaseId,
        fromCaseId: fromCaseId,
        orderList: order,
      };
      updateMoveOrder(payload, setToaster, setRefresh);
    }
  }, [submitFlag]);

  let debounceTimer;

  useEffect(() => {
    if (search !== "0" && searchQuery) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchOrderCaseData(searchQuery, setToaster);
      }, 300);
    } else {
      fetchOrderCaseData("", setToaster);
    }
  }, [search]);

  useEffect(() => {
    if (searchSecond !== "0") {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchOrderCaseDataTo(searchQuerySecond, setToaster);
      }, 300);
    } else {
      fetchOrderCaseData("", setToaster);
    }
  }, [searchSecond]);

  const handleTransfer = () => {
    setShowConfirmation(true);
  };

  const confirmTransfer = () => {
    setSubmitFlag(submitFlag+1);
    setShowConfirmation(false);
  };

  const cancelTransfer = () => {
    setShowConfirmation(false);
  };

  const handleClear = () => {
    setSearchQuery("");
    setSearch(0);
    setDisplayFirst("hide");
    setSelectedFirstItem([]);
    setSubmitFlag(0);
  };

  const handleClearSecond = () => {
    setSearchQuerySecond("");
    setSearchSecond(0);
    setDisplaySecond("hide");
    setSelectedSecondItem([]);
    setSubmitFlag(0);
  };

  const handleSearch = () => {
    setSearch(search + 11);
    setDisplayFirst("show");
    setSelectedFirstItem([]);
  };

  const handleSearchSecond = () => {
    setSearchSecond(searchSecond + 1);
    setDisplaySecond("show");
    setSelectedSecondItem([]);
  };

  const handleClickOrderId = (caseData) => {
    setDisplayFirst("none");
    setSelectedFirstItem(caseData);
    setFromCaseId(caseData?.case_id);
    setDisplayFirst("hide");
  };

  const handleClickSecondOrderId = (caseData) => {
    setDisplaySecond("none");
    setSelectedSecondItem(caseData);
    setToCaseId(caseData?.case_id);
    setDisplaySecond("hide");
  };

  return (
    <CardDiv
      title={<div className="fs-2">Order Movement System</div>}
      component={
        <div>
          <div className="d-flex align-items-end gap-5 bg-white rounded-2 shadow">
            <div className="flex-1 position relative">
              <SearchForm
                setSearchQuery={setSearchQuery}
                searchQuery={searchQuery}
                handleSearch={handleSearch}
                handleClear={handleClear}
              />
              {caseSetFirst && (
                <div
                  style={{
                    width: "26.9%",
                    maxHeight: "20rem",
                    minHeight: "1rem",
                    overflowY: "scroll",
                    position: "absolute",
                    zIndex: 100,
                  }}
                  className={`ms-3 mt-n3 scrollable-container ${
                    displayFirst !== "show" && `d-none`
                  }`}
                >
                  {Array.isArray(caseSetFirst) &&
                    caseSetFirst?.map((caseData) => {
                      return (
                        <div
                          className="card d-flex gap-2 cursor-pointer border border-2 bg-body rounded "
                          onClick={() => handleClickOrderId(caseData)}
                        >
                          <CardDiv
                            title={
                              <div className="d-flex justify-content-between px-3">
                                <div className="text-black fw-bold">
                                  {caseData?.first_name}
                                </div>
                                <SoftBadge bg="primary">
                                  {caseData?.order_display_id}
                                </SoftBadge>
                              </div>
                            }
                            component={
                              <div>
                                <div className="">
                                  <span className="fw-bold text-black">
                                    Phone:
                                  </span>
                                  <SoftBadge bg="primary">
                                    {caseData?.phone_number}
                                  </SoftBadge>
                                </div>
                                <div>
                                  <span className="fw-bold text-black">
                                    Email:
                                  </span>
                                  <SoftBadge bg="primary">
                                    {caseData?.email}
                                  </SoftBadge>
                                </div>
                              </div>
                            }
                          />
                        </div>
                      );
                    })}
                </div>
              )}
            </div>

            <div className="p-4">TO</div>
            <div className="flex-1 position relative">
              <SecondSearchForm
                setSearchQuery={setSearchQuerySecond}
                searchQuery={searchQuerySecond}
                handleSearch={handleSearchSecond}
                handleClear={handleClearSecond}
              />
              {caseDataTo && (
                <div
                  style={{
                    width: "26.9%",
                    maxHeight: "20rem",
                    minHeight: "1rem",
                    overflowY: "scroll",
                    position: "absolute",
                    zIndex: 100,
                  }}
                  className={`ms-3 mt-n3 scrollable-container ${
                    displaySecond !== "show" && `d-none`
                  }`}
                >
                  {Array.isArray(caseDataTo) &&
                    caseDataTo?.map((caseData) => {
                      return (
                        <div
                          className="card d-flex gap-2 cursor-pointer border border-2 shadow bg-body rounded "
                          onClick={() => handleClickSecondOrderId(caseData)}
                        >
                          <CardDiv
                            title={
                              <div className="d-flex justify-content-between px-3">
                                <div className="text-black fw-bold">
                                  {caseData?.first_name}
                                </div>
                                <SoftBadge bg="primary">
                                  {caseData?.order_display_id}
                                </SoftBadge>
                              </div>
                            }
                            component={
                              <div>
                                <div className="">
                                  <span className="fw-bold text-black">
                                    Phone:
                                  </span>
                                  <SoftBadge bg="primary">
                                    {caseData?.phone_number}
                                  </SoftBadge>
                                </div>
                                <div>
                                  <span className="fw-bold text-black">
                                    Email:
                                  </span>
                                  <SoftBadge bg="primary">
                                    {caseData?.email}
                                  </SoftBadge>
                                </div>
                              </div>
                            }
                          />
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-between py-3 gap-3">
            <div className="flex-1">
              <CardDiv
                component={<OrderManagement orders={selectedFirstItem} />}
              />
            </div>
            <div className="flex-1">
              <CardDiv
                component={<OrderManagement orders={selectedSecondItem} />}
              />
            </div>
          </div>

          <div className="mt-3">
            <div className="d-flex justify-content-between w-100 gap-3">
              <div className="flex-1 ">
                <OrderManagementTable
                  orders={selectedFirstItem}
                  isLoading={caseDataLoading}
                  setCheckedItems={setOrder}
                />
              </div>
              <div className="flex-1">
                <ImportantNotes />
              </div>
            </div>
          </div>
          <div>
            <div className="w-100 text-center mt-4">
              <button
                type="button"
                onClick={handleTransfer}
                class={
                  order && toCaseId
                    ? "btn btn-primary p-3 fs-1"
                    : "btn btn-primary disabled p-3 fs-1"
                }
              >
                {updateLoading ? (
                  <>
                    <Spinner animation="border" variant="warning" />
                    Transferring the Order
                  </>
                ) : (
                  "Transfer the Order"
                )}
              </button>
              {showConfirmation && (
                <Modal show={true} onHide={cancelTransfer} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Confirm Transfer</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to transfer the order?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={cancelTransfer}>
                      Cancel
                    </Button>
                    <Button variant="primary" onClick={confirmTransfer}>
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </div>
          </div>
        </div>
      }
    />
  );
};

export default OrderMovement;
